import React from 'react';
import { GlobalContext, useCombinedReducer } from '../../store/Store';
import { initialProjectState, projectReducer, ProjectState } from '../../store/projectReducer';
import { initState, projectContent, IProjectContentState } from '../../store/projectContent';
import { initialMeshState, meshReducer, MeshState } from '../../store/meshReducer';
import { authReducer, IAuthState, initialAuthState } from '../../store/authReducer';
import { mapReducer, initialMapState } from '../../store/mapReducer';
import { dataReducer, initialDataState } from '../../store/dataReducer';
import { messageReducer, initialMessageState, MessageState } from '../../store/messageReducer';
import {
  notificationReducer,
  initialNotificationState,
  NotificationState,
} from '../../store/notificationReducer';
import Map from 'ol/Map';
import {
  meshFilesPlatformReducer as mfpRed,
  initialMeshFilesPlatform as imfp,
} from '../../store/meshFilesPlatformReducer';
import { MeshFiles } from '../../apis/meshApi';

import { DatalinkAPIModels } from '../../generated/src/dlAPI';
import  ActionType  from '../../store/ActionType';
import {
  meshFilesImportedReducer as mfiRed,
  initialMeshFilesImported as imfi,
} from '../../store/meshFilesImportedReducer';
import { MeshStatus } from '../../generated/src/models';
import { progressItemsReducer } from '../../store/progressItemsReducer';
import { pollingItemsReducer } from '../../store/pollingItemsReducer';
import { pollingIdsReducer } from '../../store/pollingIdsReducer';
import { IProgressItem } from '../mike-topbar-progress-spinner';
import App from './PublicApp';

export interface ISelectedData {
  BoundaryConditions: number;
  InitialConditions: number;
  ModelForcings: number;
  ExpBoundaryConditions: number;
  ExpInitialConditions: number;
  ExpModelForcings: number;
}

export class SelectedData implements ISelectedData {
  BoundaryConditions = 0;
  InitialConditions = 0;
  ModelForcings = 0;
  ExpBoundaryConditions = 0;
  ExpInitialConditions = 0;
  ExpModelForcings = 0;
}

export interface GlobalStateData {
  extractionbuilderdata?: DatalinkAPIModels.ExtractionBuilderData;
  fetchingExtractionBuilderData: boolean;
  selected: ISelectedData;
}

export interface GlobalState {
  map: Map | undefined;
  auth: IAuthState | undefined;
  mesh: MeshState | undefined;
  meshFilesPlatform: MeshFiles | undefined;
  meshFilesImported: MeshStatus[] | undefined;
  project: ProjectState | undefined;
  projectContent: IProjectContentState | undefined;
  data: GlobalStateData | undefined;
  message: MessageState | undefined;
  progressItems: IProgressItem[];
  pollingItems: IProgressItem[];
  pollingIds: any[];
  notification: NotificationState | undefined;
}
export interface GlobalDispatchArgs {
  type: ActionType;
  data?: any;
  [key: string]: any;
}
export interface GlobalDispatch {  
  ({ type, data }: GlobalDispatchArgs): void;
}
export interface IGlobalContext {
  state: GlobalState;
  dispatch: GlobalDispatch;
}

function AppWrapper() {
  // global state management system
  const [state, dispatch] = useCombinedReducer({
    map: React.useReducer(mapReducer, initialMapState),
    auth: React.useReducer(authReducer, initialAuthState),
    mesh: React.useReducer(meshReducer, initialMeshState),
    meshFilesPlatform: React.useReducer(mfpRed, imfp),
    meshFilesImported: React.useReducer(mfiRed, imfi),
    project: React.useReducer(projectReducer, initialProjectState),
    projectContent: React.useReducer(projectContent, initState),
    data: React.useReducer(dataReducer, initialDataState),
    message: React.useReducer(messageReducer, initialMessageState),
    progressItems: React.useReducer(progressItemsReducer, []),
    pollingItems: React.useReducer(pollingItemsReducer, []),
    pollingIds: React.useReducer(pollingIdsReducer, []),
    notification: React.useReducer(notificationReducer, initialNotificationState),
  });

  return (
    <GlobalContext.Provider value={[state, dispatch]}>
      <App />
    </GlobalContext.Provider>
  );
}
export default AppWrapper;
